var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pdf-viewer" }, [
    !_vm.disableHeader
      ? _c(
          "div",
          { staticClass: "pdf-header" },
          [
            _vm.isLoading
              ? [_c("p", { staticClass: "m-2" }, [_vm._v("loading")])]
              : [
                  _c("span", [
                    _vm.showAll
                      ? _c("div", { staticClass: "pdf-page" }, [
                          _c("p", { staticClass: "m-2" }, [
                            _vm._v(_vm._s(_vm.pageCount) + " page(s)"),
                          ]),
                        ])
                      : _c("div", { staticClass: "pdf-page" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn pt-0 pb-1 m-0 px-3",
                              attrs: { disabled: _vm.currentPage <= 1 },
                              on: {
                                click: function ($event) {
                                  _vm.currentPage--
                                },
                              },
                            },
                            [_vm._v("❮")]
                          ),
                          _c("p", { staticClass: "m-2" }, [
                            _vm._v(
                              _vm._s(_vm.currentPage) +
                                " / " +
                                _vm._s(_vm.pageCount)
                            ),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "btn pt-0 pb-1 m-0 px-3",
                              attrs: {
                                disabled: _vm.currentPage >= _vm.pageCount,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.currentPage++
                                },
                              },
                            },
                            [_vm._v("❯")]
                          ),
                        ]),
                    _c("div", { staticClass: "pdf-zoom" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn pt-0 pb-1 m-0 px-3",
                          attrs: { disabled: _vm.scale <= 25 },
                          on: {
                            click: function ($event) {
                              _vm.scale = _vm.scale - 25
                            },
                          },
                        },
                        [_vm._v("-")]
                      ),
                      _c("p", { staticClass: "m-2" }, [
                        _vm._v(_vm._s(_vm.scale) + "%"),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "btn py-0 m-0 px-3",
                          attrs: { disabled: _vm.scale >= 200 },
                          on: {
                            click: function ($event) {
                              _vm.scale = _vm.scale + 25
                            },
                          },
                        },
                        [_vm._v("+")]
                      ),
                    ]),
                    _c("div", { staticClass: "pdf-download" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn ml-5 my-0 px-4",
                          attrs: {
                            disabled:
                              _vm.currentUrl === undefined ||
                              _vm.currentUrl === "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.downloadDocument()
                            },
                          },
                        },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "cloud-download",
                              "aria-hidden": "true",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
          ],
          2
        )
      : _vm._e(),
    _vm.currentUrl !== undefined && _vm.currentUrl !== ""
      ? _c(
          "div",
          { staticClass: "pdf-content", attrs: { hidden: this.lastPage } },
          [
            _vm.isLoading
              ? _c("b-spinner", { attrs: { large: "", variant: "primary" } })
              : _vm._e(),
            _c("vue-pdf-embed", {
              ref: "pdfRef",
              style: { "max-height": _vm.maxHeight + "px", padding: "8px" },
              attrs: {
                source: _vm.currentUrl,
                page: _vm.currentPage,
                width: (_vm.defaultWidth * _vm.scale) / 100,
              },
              on: { rendered: _vm.handleDocumentRender },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }